import { propIn } from '../../../common/utils/immutableHelper';

export const appIsRefreshingCurrentBoardSelector = propIn(['app', 'serverReconnection', 'isRefreshingCurrentBoard']);
